// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__370_5","title":"ClientCherryInfo_title__V97rH","itemText":"ClientCherryInfo_itemText__idpIW"};